import {cn} from '@/lib/utils';

type Props = {
  id: string;
  label: string;
  onChange: () => void;
  color: string;
  isSelected: boolean;
  hidden?: boolean;
};

export default function SurroundingsMapCheckBox({
  id,
  label,
  onChange,
  color,
  isSelected,
  hidden,
}: Props) {
  return (
    <div
      className={cn('', {
        hidden: hidden,
      })}>
      <input onChange={onChange} id={id} className="hidden" type="checkbox" />
      <label
        htmlFor={id}
        className="cursor-pointer flex mr-auto ml-0 items-center justify-start h-[44px] relative mb-0 align-baseline text-sm leading-[1.8] text-gray-700">
        <span
          style={{backgroundColor: isSelected ? color : '#f9f9f9'}}
          className={cn(
            'w-[25px] max-w-[25px] flex-[1_0_25px] h-[25px] border border-gray-200 rounded-[50px] mr-[10px] cursor-pointer',
          )}
        />
        <span
          className={cn('', {
            'text-graphite': isSelected,
          })}>
          {label}
        </span>
      </label>
    </div>
  );
}
